import actionType from './actionTypes';

export const startLoading = (isValidation) => (dispatch) => {
    try {
        dispatch({
            type: actionType.ENABLE_LOADER,
        });
        if (isValidation) {
            dispatch({
                type: actionType.VALIDATION_MESSAGE,
                payload: isValidation,
            });
        }
    } catch (error) {
        console.log(error);
    }
};
export const stopLoading = () => (dispatch) => {
    dispatch({
        type: actionType.DISABLE_LOADER,
    });
};
